<template>
    <v-card :loading="loading" min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <slot>
            <v-card-title>
                <v-layout row wrap>
                    <v-col cols="6">
                        {{ title }}
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <v-btn
                            v-if="hasAddNewButton"
                            color="primary"
                            dark
                            class="ml-2"
                            @click="addNewItem"
                        >
                            Adaugare
                        </v-btn>
                    </v-col>
                    <v-col md="5" sm="12">
                        <period-selector v-model="period" :button-class="['mt-3']"></period-selector>
                    </v-col>
                    <v-col v-if="hasRole('admin')" md="3" sm="12">
                        <user-selector v-model="filterByUser" filter-by-role="vanzari"></user-selector>
                    </v-col>
                    <v-col md="2" sm="12" class="text-right">
                        <v-select
                            :items="(new $db.Offer).statuses"
                            item-text="text"
                            item-value="id"
                            v-model="status"
                            label="Stare"
                            clearable
                            class="mr-5"
                        />
                    </v-col>
                    <v-col md="2" sm="12" class="text-right">
                        <search-field v-model="search"></search-field>
                        <v-checkbox
                            v-if="showTrashedCheckbox"
                            class="mr-5"
                            v-model="showTrashed"
                            label="Afisare informatiile sterse"
                        />
                    </v-col>
                </v-layout>

            </v-card-title>
        </slot>
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
            show-select
        >
            <template v-slot:top>
                <v-toolbar
                    flat
                >
                    <v-toolbar-title>{{ title }}</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-checkbox
                        v-if="hasRole('admin')"
                        class="mr-5 mt-3"
                        v-model="exportOptions.includeEntryPrice"
                        label="Afisare cost + furnizor"
                    />
                    <v-btn
                        v-if="selected.length > 1"
                        color="primary"
                        dark
                        class="mb-2"
                        @click="downloadSelected"
                    >
                        Descarcare elemente selectate
                    </v-btn>
                    <v-btn
                        color="primary"
                        dark
                        class="ml-2"
                        @click="createExport"
                    >
                        Export PDF
                    </v-btn>
                </v-toolbar>
            </template>
            <template v-slot:item.created_by="{ item }">
                {{ item.created_by.name }}
            </template>
            <template v-slot:item.status="{ item }">
                <v-chip small :color="item.status_color">{{ item.status_friendly }}</v-chip>
            </template>
            <template v-slot:item.document_no="{ item }">
                {{ item.document_number }}
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ new Date(item.created_at) | date }}
            </template>
            <template v-slot:item.customer_id="{ item }">
                {{ _.get(item, 'customer.name') }} {{ _.get(item, 'customer.surname') }}
            </template>
            <template v-slot:item.amount_with_vat="{ item }">
                {{ item.amount_with_vat | price }}
            </template>
            <template v-slot:item.profitability_segments="{ item }">
                TOTAL: {{ item.profitability_segments.TOTAL | percent }}<br/>
                {{ item.profitability_segments.PRODUCT | percent }} / {{ item.profitability_segments.SERVICE | percent }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn
                    color="primary"
                    x-small
                    class="mr-2"
                    outlined
                    rounded
                    fab
                    @click="downloadOffer(item)"
                >
                    <v-icon small>
                        mdi-file-pdf
                    </v-icon>
                </v-btn>
                <v-btn
                    v-if="item.eow_no"
                    color="primary"
                    small
                    class="mr-2"
                    outlined
                    rounded
                    @click="downloadWorksheet(item)"
                >
                    Deviz
                </v-btn>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import SmartTable from "Components/SmartTable";
    import PeriodSelector from "Components/common/PeriodSelector";
    import UserSelector from "Components/common/UserSelector";
    import ACL from "Mixins/acl";
    import {Form} from "vform";
    export default {
        mixins: [ACL],
        components: {
            PeriodSelector,
            UserSelector
        },
        extends: SmartTable,
        data: () => ({
            title: 'Raport status oferte',
            loading: false,
            dialog: false,
            selected: [],
            headers: [
                { text: 'Stare', value: 'status' },
                { text: 'Numar oferta', value: 'document_no' },
                { text: 'Data', value: 'created_at' },
                { text: 'Valoare', value: 'amount_with_vat' },
                { text: "Profitabilitate", value: 'profitability_segments' },
                { text: 'Client', value: 'customer_id' },
                { text: 'Emis de', value: 'created_by' },
                { text: 'Actiuni', value: 'actions' }
            ],
            options: {
                sortBy: ['id'],
                sortDesc: [true]
            },
            items: [],
            editedIndex: -1,
            showTrashedCheckbox: true,
            showTrashed: false,
            period: [window.moment().subtract(1, 'month').toISOString(), window.moment().toISOString()],
            filterByUser: null,
            status: null,
            exportOptions: {
                includeEntryPrice: false
            }
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            showTrashed: {
                handler(val) {
                    this.initialize()
                }
            },
            period: {
                async handler(val) {
                    await this.initialize()
                }
            },
            filterByUser: {
                async handler(val) {
                    await this.initialize()
                }
            },
            status: {
                async handler(val) {
                    await this.initialize()
                }
            }
        },

        async created () {
            await this.initialize()
            let downloadOfferId = this.$route.query?.downloadOffer || 0
            if (parseInt(downloadOfferId) > 0) {
                this.downloadOffer({id: downloadOfferId})
            }
            let downloadEowId = this.$route.query?.downloadEow || 0
            if (parseInt(downloadEowId) > 0) {
                this.downloadWorksheet({id: downloadEowId})
            }
        },

        methods: {
            async initialize () {
                this.loading = true
                var query = this.getQuery()
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.selected = []
                this.loading = false
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            async downloadOffer(item) {
                const downloadEndpoint = new this.$db.Offer({id: item.id}).downloadEndpoint
                this.loading = true
                return window.axios.get(`${downloadEndpoint}`, {
                    responseType: 'blob',
                    params: this.exportOptions
                }).then((response) => {
                    const contentDisposition = this._.get(response, 'headers.content-disposition')
                    const filename = contentDisposition.split("filename=")[1];
                    const downloadUrl = window.URL.createObjectURL(new Blob([response?.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', filename); //any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }).catch((err) => {
                    console.error(err)
                }).finally(() => {
                    this.loading = false
                })
            },

            async downloadWorksheet(item) {
                let downloadEndpoint = new this.$db.Offer({id: item.id}).downloadEstimateOfWork
                this.loading = true
                return window.axios.get(`${downloadEndpoint}`, {
                    responseType: 'blob',
                    params: this.exportOptions
                }).then((response) => {
                    const contentDisposition = this._.get(response, 'headers.content-disposition')
                    const filename = contentDisposition.split("filename=")[1];
                    const downloadUrl = window.URL.createObjectURL(new Blob([response?.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', filename); //any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }).catch((err) => {
                    console.error(err)
                }).finally(() => {
                    this.loading = false
                })
            },
            getQuery(extraParams) {
                var query = this.$db.Offer
                    .append('document_number', 'profitability_segments')
                    .include('customer', 'createdBy')
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params(Object.assign({
                        query: this.search
                    }, extraParams))
                if(this.period instanceof Array && this.period.length === 2) {
                    query = query.where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))
                }
                if(this.showTrashed) query = query.where('onlyTrashed', true)
                if(!this._.isNil(this.filterByUser)) query = query.where('created_by', this.filterByUser.join(','))
                if(!this._.isNil(this.status)) query = query.where('status', this.status)
                return query
            },
            async createExport() {
                this.loading = true
                let query = this.getQuery({export: true})
                let base = query._fromResource || `${query.baseURL()}/${query.resource()}`
                base = query._customResource
                    ? `${query.baseURL()}/${query._customResource}`
                    : base
                let url = `${base}${query._builder.query()}`
                return window.axios.get(`${url}`, {
                    responseType: 'blob',
                    params: this.exportOptions
                }).then((response) => {
                    const contentDisposition = this._.get(response, 'headers.content-disposition')
                    const filename = contentDisposition.split("filename=")[1];
                    const downloadUrl = window.URL.createObjectURL(new Blob([response?.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', filename); //any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }).catch((err) => {
                    console.error(err)
                }).finally(() => {
                    this.loading = false
                })
            },

            async downloadSelected() {
                this.loading = true
                this.asyncForEach(this.selected, async(offer) => {
                    await this.downloadFile(offer.downloadEndpoint, this.exportOptions)
                        .catch((e) => {
                            this.showError(e.toString())
                        })
                }).finally(() => {
                    this.loading = false
                })
            }
        },
    };
</script>
